class BeatInfo {
    constructor(id, name, url, bars = 1) {
        this.timeSignature = { beatUnit: 4, beatsPerBar: 4 }; // ^= 4/4
        this.id = id;
        this.name = name;
        this.url = url;
        this.bars = bars;
    }
    setDuration(_duration) {
        this.duration = _duration;
    }
    get durationPerBar() {
        return this.duration / this.bars;
    }
    get durationPerBeat() {
        return this.durationPerBar / (this.bars * this.timeSignature.beatsPerBar);
    }
    get bpm() {
        return this.timeSignature.beatsPerBar * 60 / (this.duration / this.bars);
    }
}
export default BeatInfo;
export { BeatInfo, };
